/* eslint-disable @typescript-eslint/no-empty-function */
import React from 'react';
import dynamic from 'next/dynamic';
import { NewWidgetTitle, NewRentalWidget } from 'views/rebranded-module/common/components/UI/NewMainWidget';
import { RENTAL_WIDGET, TOUR_WIDGET } from 'lib/utils/mainWidgetConstants';
import StyledBox from 'views/rebranded-module/common/components/UI/NewMainWidget/NewMainWidget.styles';

const AnnouncementBarV2 = dynamic(() => import('views/rebranded-module/common/components/UI/AnnouncementBarV2').then(
  (file) => file.AnnouncementBarV2,
));

const NewWidgetAlert = dynamic(() => import('views/rebranded-module/common/components/UI/NewMainWidget/NewWidgetAlert').then(
  (file) => file.NewWidgetAlert,
));
const NewTourWidget = dynamic(() => import('views/rebranded-module/common/components/UI/NewMainWidget/NewTourWidget').then(
  (file) => file.NewTourWidget,
));

const rentalWidgetDummyData = {
  pickup: { locationsDummyData: [], time_slots: [], min_date: null, max_date: null },
  dropoff: { locationsDummyData: [], time_slots: [], min_date: null, max_date: null },
  locationsDummyData_geographical_data: [],
};
const locationsDummyData = {
  pickup: [],
  dropoff: [],
};
const formData = {
  reservation: { vehicles_count: 1 },
};
const initTourWidgetData = {
  selectedCountry: null,
  selectedCity: null,
  selectedTour: null,
  countries: [],
  cities: [],
  tours: [],
};
const NewMainWidgetForCrawlers = (props) => {
  const {
    shouldHideTitle,
    vertical,
    className,
    alertMassage,
    titleColor,
    announcementBar,
    widgetInfo,
    handleWidgetTypeSelect,
    renderAllWidget = true,
    handleRenderAllWidget = () => {},
    showStartYourAdventureLabel,
    ...other
  } = props;
  // eslint-disable-next-line consistent-return
  const renderAnnouncment = () => {
    if (announcementBar) {
      return <AnnouncementBarV2 vertical={vertical} />;
    }
  };
  const renderWidget = () => {
    const rentalWidget = (
      <NewRentalWidget
        pickupData={{
          locationsDummyData: locationsDummyData.pickup,
          minDate: rentalWidgetDummyData.pickup.min_date,
          maxDate: rentalWidgetDummyData.pickup.max_date,
          timeSlots: rentalWidgetDummyData.pickup.time_slots,
        }}
        dropoffData={{
          locationsDummyData: locationsDummyData.dropoff,
          minDate: rentalWidgetDummyData.dropoff.min_date,
          maxDate: rentalWidgetDummyData.dropoff.max_date,
          timeSlots: rentalWidgetDummyData.dropoff.time_slots,
        }}
        motorcycleList={[
          {
            number: '1',
          },
          {
            number: '2',
            discount: '-6',
          },
          {
            number: '3',
            discount: '-9',
          },
          {
            number: '4',
            discount: '-13',
          },
          {
            number: '5',
            discount: '-17',
          },
          {
            number: '6+',
            discount: '-20',
          },
        ]}
        handleLocationInputChange={() => {}}
        formData={formData}
        handleFormDataChange={() => {}}
        handleWidgetTypeChange={() => {}}
        shouldDisableDate={() => {}}
        returnToDifferentLocation
        handleReturnToDifferentLocation={() => {}}
        isOptionsLoading={false}
        handleSearchButtonClick={() => {}}
        handleRenderAllWidget={handleRenderAllWidget}
        errors={{}}
        vertical={vertical}
        renderAllWidget={false}
        {...other}
      />
    );
    switch (widgetInfo.type) {
      case RENTAL_WIDGET:
        return rentalWidget;
      case TOUR_WIDGET:
        return (
          <NewTourWidget
            citiesList={initTourWidgetData.cities}
            countriesList={initTourWidgetData.countries}
            toursList={initTourWidgetData.tours}
            handleSelectInputChange={() => {}}
            selectedOptions={{}}
            handleSearchButtonClick={() => {}}
            {...props}
          />
        );
      default:
        return rentalWidget;
    }
  };
  return (
    <StyledBox className={`mainWidget ${className}`}>
      {!shouldHideTitle && (
        <NewWidgetTitle
          widgetInfo={widgetInfo}
          vertical={vertical}
          titleColor={titleColor}
          handleWidgetTypeSelect={handleWidgetTypeSelect}
          showStartYourAdventureLabel={showStartYourAdventureLabel}
        />
      )}
      {alertMassage && <NewWidgetAlert alertMassage={alertMassage} />}
      {renderWidget()}
      {renderAllWidget && renderAnnouncment()}
    </StyledBox>
  );
};

export { NewMainWidgetForCrawlers };